module.exports = __webpack_public_path__ + "static/media/smk3.ce0ba121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smk3.png
// module id = 1586
// module chunks = 0